module.exports = __webpack_public_path__ + "img/area-part3-mind.d6225278.png";